import { useAccount } from "@azure/msal-react";
import { useUser } from "src/hooks/useUser";
import { useExternalUser } from "src/utils/useExternalUser";

export const useAdmin = () => {
    const { data: user, isLoading } = useUser();
    if (isLoading || !user) return false;
    return user.info.roles.includes("ks_admin");
};

export const useNotAuthorizedUser = () => {
    const account = useAccount();
    const { data: user, isLoading } = useUser();
    const isAdmin = useAdmin();
    const isExternalUser = useExternalUser();

    if (!account) return null;

    // If user data is still loading, don't show unauthorized yet
    if (isLoading) return false;

    if (isAdmin || isExternalUser) {
        return false; // Admin and external users are always authorized
    }

    // If we have user data, check if user has any accessible datasources
    if (user) {
        const hasAccessibleDatasources = user.datasources?.some((ds) => ds.has_access);
        // User is unauthorized if they have no accessible datasources
        if (!hasAccessibleDatasources) {
            return true;
        }
    }

    return false;
};
